export const apiEndpoints = {
    LOGIN: 'api/jwt/login/',
    LOGOUT: 'api/logout/',
    JWT_REFRESH: 'api/auth/jwt/refresh/',
    GET_TICKER_NEWS: 'api/list/news_ticker/',
    UPDATE_PROFILE: 'api/update_user/',
    CHANGE_PASSWORD: 'api/list/user/set_password/',
    FORGET_PASSWORD: 'api/list/user/reset_password/',
    RESET_PASSWORD: 'api/list/user/reset_password_confirm/',
    CHANGE_COUNTRY: 'api/country/',
    LOAD_MAP: 'api/map/incidents/?showall=true',
    MAP_FILTER_RESULT: 'api/map/incidents/',
    MAP_FILTER_META_RESULT: 'api/map/filter_meta/',
    POLYGON: 'api/map/polygon/',
};